import React, { useState } from 'react';
import { ModalContainer } from '../style';
import Siginin from './siginin';
import Signup from './signup';

const ModalContent = () => {
  const [step, setStep] = useState(0);

  const stepData = [
    {
      title: 'sign in',
    },
    {
      title: 'sign up',
    },
  ];

  const steps = [<Siginin key={step} />, <Signup key={step + 1} />];
  return (
    <ModalContainer>
      <div className="header">
        {stepData.map((data, indx) => (
          <div
            className={step === indx ? 'title_active' : 'title'}
            onClick={() => setStep(indx)}
            key={indx}
          >
            {data.title}
          </div>
        ))}
      </div>
      <div>{steps[step]}</div>
    </ModalContainer>
  );
};

export default ModalContent;
